import type {
  EditableIndividualProfile,
  MdmContactUse,
  PartyAddressProfile,
  PhoneContact,
} from "@/lib/cat/individual-profile.types";
import { EMPTY_EDITABLE_INDIVIDUAL_PROFILE } from "@/lib/cat/individual-profile.types";

export type EditableCompanyProfile = PartyAddressProfile & {
  companyDenomination: string;
  apeCode: string;
  email: string;
  fixedPhone: PhoneContact;
  mobilePhone: PhoneContact;
};

export const EMPTY_EDITABLE_COMPANY_PROFILE: EditableCompanyProfile = {
  companyDenomination: "",
  apeCode: "",
  email: "",
  addressLine: "",
  addressFloorApartment: "",
  addressBuildingResidence: "",
  postBox: "",
  postalCode: "",
  city: "",
  fixedPhone: { value: "", use: "unknown" },
  mobilePhone: { value: "", use: "unknown" },
};

export function individualProfileToCompanyBase(
  base: EditableIndividualProfile,
): Omit<EditableCompanyProfile, "companyDenomination" | "apeCode"> {
  return {
    email: base.email,
    addressLine: base.addressLine,
    addressFloorApartment: base.addressFloorApartment,
    addressBuildingResidence: base.addressBuildingResidence,
    postBox: base.postBox,
    postalCode: base.postalCode,
    city: base.city,
    fixedPhone: base.fixedPhone,
    mobilePhone: base.mobilePhone,
  };
}

export type { MdmContactUse, PhoneContact };

export { EMPTY_EDITABLE_INDIVIDUAL_PROFILE };
